// Copyright (C) 2021-Present CITEC Inc. <https://citecsolutions.com/>
// All rights reserved
//
// This file is part of CITEC Inc. source code.
// This software framework contains the confidential and proprietary information
// of CITEC Inc., its affiliates, and its licensors. Your use of these
// materials is governed by the terms of the Agreement between your organization
// and CITEC Inc., and any unauthorized use is forbidden. Except as otherwise
// stated in the Agreement, this software framework is for your internal use
// only and may only be shared outside your organization with the prior written
// permission of CITEC Inc.
// CITEC Inc. source code can not be copied and/or distributed without the express
// permission of CITEC Inc.

import type { Document } from '@shared/data-access/types/engine-types';
import type { TFunction } from 'i18next';

const dateFormatOptions: Intl.DateTimeFormatOptions = {
  day: 'numeric',
  month: 'short',
  year: 'numeric',
};

const formatDate = (value: string, locale: string): string =>
  new Intl.DateTimeFormat(locale, dateFormatOptions).format(new Date(value));

/** Footer dates for mobile document cards. */
export const getDocumentCardDateLabels = (
  document: Document,
  t: TFunction,
  locale: string,
): string[] => {
  const labels: string[] = [];

  if (document.document_date) {
    labels.push(
      t('documents.card.document-date', {
        ns: 'components',
        date: formatDate(document.document_date, locale),
      }),
    );
  }

  if (document.expiry_date) {
    labels.push(
      t('documents.card.expires', {
        ns: 'components',
        date: formatDate(document.expiry_date, locale),
      }),
    );
  }

  return labels;
};
